module.exports = __webpack_public_path__ + "img/prabhudas.fa77e2d5.png";